import { networkCall } from "../../../../../utils/network-call/network-call";

export const AdminActiveCompanyListLoader = async () => {
    const getCompaniesResponse = await networkCall('/companies', {
        params: { deleted: 'false' }
    });
    return { getCompaniesResponse };
};